// export const makeJSONUnique = (json) => {
//   const uniqueJSON = JSON.parse(JSON.stringify(json))

//   function makeKeysUnique(obj) {
//     for (const key in obj) {
//       if (typeof obj[key] === "object") {
//         makeKeysUnique(obj[key])
//       } else {
//         if (obj[key] === "") {
//           obj[key] = ""
//         }
//       }
//     }
//   }

//   makeKeysUnique(uniqueJSON)

//   return uniqueJSON
// }

export function formatJSONString(jsonString, indentation = 2) {
  let level = 0
  let inString = false
  let result = ""

  for (let i = 0; i < jsonString.length; i++) {
    const char = jsonString[i]

    if (char === "{" || char === "[") {
      level++
      result += char + "\n" + " ".repeat(level * indentation)
    } else if (char === "}" || char === "]") {
      level--
      result = result.trimEnd() + "\n" + " ".repeat(level * indentation) + char
    } else if (char === ":") {
      result += char + " "
    } else if (char === ",") {
      result += char + "\n" + " ".repeat(level * indentation)
    } else {
      result += char
    }

    if (char === '"' && jsonString[i - 1] !== "\\") {
      inString = !inString
    }
  }

  return result
}
